(() => {
  const rootSel = 'header-drawer.mc-nav-drawer';

  function panelEls(root) {
    return {
      openBtn: root.querySelector('[data-mc-collections-open]'),
      backBtn: root.querySelector('[data-mc-collections-back]'),
      panel: root.querySelector('[data-mc-collections-panel]'),
      main: root.querySelector('.mc-nav-drawer__main'),
    };
  }

  function setOpen(root, open) {
    const { openBtn, panel, main } = panelEls(root);
    if (!panel || !openBtn) return;
    panel.hidden = !open;
    openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    root.classList.toggle('mc-nav-collections-open', open);
    if (main) main.classList.toggle('mc-nav-collections-open', open);
    if (open) {
      const back = root.querySelector('[data-mc-collections-back]');
      if (back) back.focus({ preventScroll: true });
    } else {
      openBtn.focus({ preventScroll: true });
    }
  }

  function bind(root) {
    if (root.dataset.mcCollectionsBound === '1') return;
    root.dataset.mcCollectionsBound = '1';
    const { openBtn, backBtn, panel } = panelEls(root);
    if (!openBtn || !panel) return;

    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      setOpen(root, true);
    });
    if (backBtn) {
      backBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(root, false);
      });
    }

    // Reset when drawer closes
    const obs = new MutationObserver(() => {
      const open = root.classList.contains('is-open') || root.classList.contains('is-visible');
      if (!open) setOpen(root, false);
    });
    obs.observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    document.querySelectorAll(rootSel).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
